module.exports = __webpack_public_path__ + "img/service3-1.fbb4b2c9.webp";